<template>
<div class='console-tips'>
  <div v-if="consoleTipsList && consoleTipsList[index]" v-html="consoleTipsList[index].content"></div>
</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return { index: this.$route.params.index }
  },
  computed: {
    ...mapState('consoleTips', {
      consoleTipsList: state => state.consoleTipsList.consoleTipsBusiness
    })
  },
  mounted () {
    console.log(this.consoleTipsList[this.index])
  }
}
</script>
<style scoped lang='scss'>
.console-tips {
  overflow: auto;
  height: 100vh;
  padding: 0 torem(10px);
}
</style>
